// components/inventory/InventoryInOutButton.tsx
import { useQueryClient } from "@tanstack/react-query";
import { useSetRecoilState } from "recoil";
import {
  InOutModalTitleState,
  inOutResetFieldsState,
  inventoryModalTitleState,
} from "../../utils/atoms/atoms";

interface Props {
  part_id: number;
  type: "in" | "out";
}

const IN_STATUS_VALUE = 0; // <-- confirm against your inOutStatus dropdown values
const OUT_STATUS_VALUE = 1; // <-- confirm against your inOutStatus dropdown values

const InventoryInOutButton = ({ part_id, type }: Props) => {
  const queryClient = useQueryClient();
  const setInOutModalTitle = useSetRecoilState(inventoryModalTitleState);
  const setInOutResetFields = useSetRecoilState(inOutResetFieldsState);

  const handleClick = () => {
    const today = new Date().toISOString().split("T")[0];

    queryClient.setQueryData(["in-out-item"], {
      part_id,
      status: type === "in" ? IN_STATUS_VALUE : OUT_STATUS_VALUE,
      action_date: today,
      quantity: 0,
      remarks: "",
      party_id: undefined,
    });

    setInOutModalTitle(type === "in" ? "New In Entry" : "New Out Entry");
    setInOutResetFields(true);
  };

  return (
    <button
      type="button"
      className={type === "in" ? "styled-btn--in m-1" : "styled-btn--out m-1"}
      data-bs-toggle="modal"
      data-bs-target="#inOutModal"
      onClick={handleClick}
    >
      {type === "in" ? "IN" : "OUT"}
    </button>
  );
};

export default InventoryInOutButton;
